export default __webpack_public_path__ + "static/media/twitter.e9ab4bbd.svg";